var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4c5.72 0 10.357 4.477 10.357 10S20.22 24 14.5 24 4.143 19.523 4.143 14 8.78 4 14.5 4zm0 2c-4.576 0-8.286 3.582-8.286 8s3.71 8 8.286 8 8.286-3.582 8.286-8-3.71-8-8.286-8zm-1.071 13c-.553 0-1-.448-1-1s.447-1 1-1h.035v-4h-.035c-.553 0-1-.448-1-1s.447-1 1-1h1.107c.552 0 1 .448 1 1l-.001 5h.036c.553 0 1 .448 1 1s-.447 1-1 1H13.43zm1.107-11c.552 0 1 .448 1 1s-.448 1-1 1h-.072c-.552 0-1-.448-1-1s.448-1 1-1h.072z",
    transform: "translate(-624 -380) translate(365 320) translate(0 40) translate(248 20) translate(11)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.024a4d427786c9b91f4a689248d3906d.svg";
export { ForwardRef as ReactComponent };